"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.ErrorBanner = void 0;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var styles_1 = require("./styles");
exports.ErrorBanner = function (_a) {
    var bannerBody = _a.bannerBody, bannerLabel = _a.bannerLabel;
    return (React.createElement(styles_1.BannerWrapper, null,
        React.createElement(design_language_1.InlineChildren, null,
            React.createElement(design_language_1.Icon, { color: design_language_1.Icon.Colors.SystemYellow40, type: design_language_1.Icon.Types.WarningFill }),
            React.createElement(design_language_1.StackChildren, { size: design_language_1.StackChildren.Sizes.XxxxSmall },
                React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.BannerLabel }, bannerLabel),
                React.createElement(design_language_1.Text, { styles: design_language_1.Text.Styles.BannerBody }, bannerBody)))));
};
